module.exports = __webpack_public_path__ + "static/shareLand1BG-9ef42d324ad4c9ac9b1f92788f29876b.png";